import { Modal } from 'react-bootstrap';
import EditModal from './shared_edit_modal';
import React, { useState } from 'react';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray, getChildCompanyUrlSuffix } from './shared';
import PropTypes from 'prop-types';
import Button from 'shared/button';

export default function Certifications(props) {
  const [certifications, setCertifications] = useState(props.certifications);
  const [modalObject, setModalObject] = useState({ isOpen: false, id: '' });
  const [error, setError] = useState('');

  const openModal = id => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const certificationToEdit = modalObject.id === '' ? null : certifications.find(cert => cert.id === modalObject.id);

  const handleFormSubmit = (newCertification) => {
    modifyRecordArray(newCertification, setCertifications, certifications, 'initials', modalObject, closeModal);
  };

  const deleteCertification = ({ initials, id }) => {
    const urlSuffix = getChildCompanyUrlSuffix();
    deleteRecord(id, initials, '/broker_certifications', 'Certification', setCertifications, setError, urlSuffix);
  };

  const editFields = [
    { name: 'initials', isRequired: true, value: certificationToEdit?.initials },
    { name: 'label', isRequired: false, value: certificationToEdit?.label }
  ];

  const addNewCertification = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        dialogClassName="modal-sm"
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          databaseName="broker_certification"
          editFields={editFields}
          id={modalObject.id}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          objectName="Designations"
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 align-items-center">
        <h2 className="m-0">Broker Designations</h2>
        <Button.Primary type="button" onClick={addNewCertification}>Add Designations</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Designation"
        deleteRecord={deleteCertification}
        firstColumnIdentifier="initials"
        openModal={openModal}
        recordName="Designation"
        records={certifications}
        secondColumnIdentifier="label"
        onClick={addNewCertification}
      />

      {certifications.length > 0 && (
        <div className="text-muted">Only Initials will show on marketing materials</div>
      )}
    </React.Fragment>
  );
}

export const certificationPropTypes = {
  certifications: PropTypes.arrayOf(PropTypes.shape({
    canModify: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    initials: PropTypes.string.isRequired,
    label: PropTypes.string
  })).isRequired,
};

Certifications.propTypes = {
  ...certificationPropTypes
};
